module.exports = __webpack_public_path__ + "static/img/guang.0f7a5a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/2020/pc/guang.png
// module id = lLlx
// module chunks = 69